import ParticleGenerator from './ParticleGenerator';

export class CanvasParticles {
  canvas: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  generator: ParticleGenerator;
  rafID?: number;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.generator = new ParticleGenerator(this.canvas);
    this.update();
  }

  update = () => {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.generator.animate();
    this.rafID = requestAnimationFrame(this.update);
  };

  stop = () => {
    if (this.rafID) {
      cancelAnimationFrame(this.rafID);
      this.rafID = undefined;
    }
  };
}

export default CanvasParticles;
